import { CategoryType } from "../types/category";

interface CategoryColors {
  hex: string;
  tailwind: string;
}

const categoryColorMap: Record<CategoryType | string, CategoryColors> = {
  afforestation: {
    hex: "#FF6684",
    tailwind: "bg-rose-100 text-rose-800 border-rose-300",
  },
  communityEngagement: {
    hex: "#FF98EC",
    tailwind: "bg-pink-100 text-pink-800 border-pink-300",
  },
  forestInfrastructure: {
    hex: "#FFD747",
    tailwind: "bg-yellow-100 text-yellow-800 border-yellow-300",
  },
  forestSanitation: {
    hex: "#4B62E1",
    tailwind: "bg-indigo-100 text-indigo-800 border-indigo-300",
  },
  forestTending: {
    hex: "#90DFED",
    tailwind: "bg-cyan-100 text-cyan-800 border-cyan-300",
  },
  harvesting: {
    hex: "#FF9E6F",
    tailwind: "bg-orange-100 text-orange-800 border-orange-300",
  },
  inventory: {
    hex: "#38A169",
    tailwind: "bg-green-100 text-green-800 border-green-300",
  },
  natureConservation: {
    hex: "#B794F4",
    tailwind: "bg-purple-100 text-purple-800 border-purple-300",
  },
  regeneration: {
    hex: "#ADCD7A",
    tailwind: "bg-lime-100 text-lime-800 border-lime-300",
  },
  wildlifeManagement: {
    hex: "#A1292B",
    tailwind: "bg-red-100 text-red-800 border-red-300",
  },
};

const defaultColors: CategoryColors = {
  hex: "#9CA3AF",
  tailwind: "bg-gray-100 text-gray-800 border-gray-300",
};

export const getCategoryHexColor = (category: CategoryType): string => {
  return categoryColorMap[category]?.hex || defaultColors.hex;
};

export const getCategoryTailwindColor = (category: CategoryType): string => {
  return categoryColorMap[category]?.tailwind || defaultColors.tailwind;
};
